import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Cable,
  LayoutGrid,
  Footprints,
  Car,
  Stethoscope,
  Package,
  Layers,
  Tent,
  ToyBrick,
  HardHat,
  ArrowRight,
} from "lucide-react";
import { PageHero } from "@/components/SectionHeader";
import { INDUSTRIES } from "@/lib/siteData";

const iconMap = {
  Cable,
  LayoutGrid,
  Footprints,
  Car,
  Stethoscope,
  Package,
  Layers,
  Tent,
  ToyBrick,
  HardHat,
};

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHero
        testid="industries-hero"
        eyebrow="Industries We Serve"
        title="Ten industries. One growing plasticiser venture."
        description="Our plasticisers are engineered for compounds, films, profiles, cables and coated fabrics across every corner of the flexible-PVC economy."
      />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {INDUSTRIES.map((ind) => {
            const Icon = iconMap[ind.icon] || Layers;
            return (
              <div
                key={ind.name}
                data-testid={`industry-card-${ind.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="group relative bg-white border border-slate-100 rounded-2xl p-7 hover:shadow-lg transition-all duration-300 overflow-hidden hover:-translate-y-1"
              >
                <div className="absolute inset-x-0 top-0 h-1 gradient-accent opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="w-12 h-12 rounded-xl gradient-accent-soft flex items-center justify-center text-indigo-600 mb-5">
                  <Icon size={22} />
                </div>
                <h3 className="font-display text-xl uppercase font-bold text-slate-900 leading-tight">
                  {ind.name}
                </h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                  {ind.blurb}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 bg-slate-50 border border-slate-100 rounded-2xl p-10 text-center">
          <h2 className="font-display text-3xl sm:text-4xl uppercase font-bold text-slate-900">
            Don't see your industry?
          </h2>
          <p className="mt-3 text-slate-600 max-w-xl mx-auto">
            Plasticisers find their way into hundreds of applications. Tell us
            your end-use and we'll recommend the right grade.
          </p>
          <Link to="/quote" data-testid="industries-cta-link">
            <Button className="mt-7 gradient-accent text-white font-semibold uppercase tracking-wider rounded-md h-12 px-7">
              Talk to Our Team <ArrowRight size={18} className="ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
